export default __webpack_public_path__ + "static/media/blue-cross-blue-shield-vector-logo.2ba52044.png";